import React, { useState } from "react"
import "semantic-ui-css/semantic.min.css"

const BankSelector = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState("")

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const handleFilterSelect = (filter) => {
    setSelectedFilter(filter)
    setIsFilterOpen(false)
  }

  return (
    <div className="additional-buttons">
      <button
        type="button"
        className="facetselector ui button"
        onClick={toggleFilter}
      >
        <i className="university icon" />
        Bank
      </button>
      {isFilterOpen && (
        <div className="filter-popup bank-popup">
          <h4>Bank</h4>
          <div className="filter-options">
            <div>
              <input
                type="text"
                placeholder="Enter a bank name"
                className="researchbank-input"
              />
            </div>
            <div
              className="selection"
              onClick={() => handleFilterSelect("All")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect("All") }}
              role="button"
              tabIndex="0"
            >
              <button type="button" className="selectall ui button">Selection All</button>
            </div>
            <div
              className="selection"
              onClick={() => handleFilterSelect("Barclays")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect("Barclays") }}
              role="button"
              tabIndex="0"
            >
              <label htmlFor="Barclays" className="label-filter-button">
                <input type="checkbox" name="Barclays" />
                Barclays
              </label>
            </div>
            <div
              className="selection"
              onClick={() => handleFilterSelect("BECM")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect("BECM") }}
              role="button"
              tabIndex="0"
            >
              <label htmlFor="BECM" className="label-filter-button">
                <input type="checkbox" name="qonto" />
                BECM
              </label>
            </div>
            <div
              className="selection"
              onClick={() => handleFilterSelect("Caisse d'épargne")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect("Caisse d'épargne") }}
              role="button"
              tabIndex="0"
            >
              <label htmlFor="CaisseEpargne" className="label-filter-button">
                <input type="checkbox" name="caisseepargne" />
                Caisse d&apos;épargne
              </label>
            </div>
            <div
              className="selection"
              onClick={() => handleFilterSelect("Hello Bank")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleFilterSelect("Hello Bank") }}
              role="button"
              tabIndex="0"
            >
              <label htmlFor="HelloBank" className="label-filter-button">
                <input type="checkbox" name="hellobank" />
                Hello Bank
              </label>
            </div>
            <button
              type="button"
              className="ui button"
              onClick={() => setIsFilterOpen(false)}
              style={{ marginTop: "10px" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {selectedFilter && (
        <div className="selected-filter">
          <p>
            Filtre sélectionné :
            {' '}
            <strong>{selectedFilter}</strong>
          </p>
          <button
            type="button"
            className="ui button"
            onClick={() => setSelectedFilter("")}
            style={{ marginTop: "10px" }}
          >
            Clear Selection
          </button>
        </div>
      )}
    </div>
  )
}

export default BankSelector
